var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 20.25C2.75625 20.25 2.22656 20.0297 1.78594 19.5891C1.34531 19.1484 1.125 18.6187 1.125 18V3.375H0V1.125H5.625V0H12.375V1.125H18V3.375H16.875V18C16.875 18.6187 16.6547 19.1484 16.2141 19.5891C15.7734 20.0297 15.2437 20.25 14.625 20.25H3.375ZM14.625 3.375H3.375V18H14.625V3.375ZM5.625 15.75H7.875V5.625H5.625V15.75ZM10.125 15.75H12.375V5.625H10.125V15.75Z",
    fill: "#EF4240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.117c7f9436eeba3fb15dc44a6128b692.svg";
export { ForwardRef as ReactComponent };